import React from "react";
import { FormGroup, Grid, RadioGroup } from "@material-ui/core";
import { Field, BaseProps } from "./field";

type Props = Pick<BaseProps, "label" | "error"> & {
  radio?: boolean;
  spacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;
};

export const Group: React.FC<Props> = (props) => {
  return (
    <Field label={props.label} error={props.error} size={12}>
      {props.radio ? (
        <RadioGroup>
          <Grid
            container
            spacing={props.spacing === undefined ? 2 : props.spacing}
          >
            {props.children}
          </Grid>
        </RadioGroup>
      ) : (
        <FormGroup>
          <Grid
            container
            spacing={props.spacing === undefined ? 2 : props.spacing}
          >
            {props.children}
          </Grid>
        </FormGroup>
      )}
    </Field>
  );
};
